module.exports = __webpack_public_path__ + "static/media/ai-ad-ossoff-thumbnailDT.c330ed9a.jpg";